const getParser = async () => import("@rei/rich-text-renderer");
async function findContentNodes(content) {
  var _a;
  if (!content) return void 0;
  const convertToHtml = (await getParser()).default;
  let concatenatedContent = "";
  if (content.sections) {
    concatenatedContent = content.sections.reduce((acc, section) => {
      var _a2;
      let inProgress = acc;
      if (section.heading) inProgress += `<h2>${section.heading}</h2>`;
      inProgress += convertToHtml((_a2 = section == null ? void 0 : section.body) == null ? void 0 : _a2.json);
      return inProgress;
    }, "");
  }
  if (content.heading || content.body || concatenatedContent) {
    return {
      title: content.heading,
      content: convertToHtml((_a = content == null ? void 0 : content.body) == null ? void 0 : _a.json) + concatenatedContent
    };
  }
  if (content.edges) {
    const nextNode = content.edges[0].node.sections ? content.edges[0].node : content.edges[0].node.content;
    const next = findContentNodes(nextNode);
    if (next) return next;
  }
}
async function membershipHelper(response, nodeFinder = findContentNodes) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { content } = response.data.pdp_hub;
  const parsedContent = {};
  const footnote = (_i = (_h = (_g = (_f = (_e = (_d = (_c = (_b = (_a = content == null ? void 0 : content.edges) == null ? void 0 : _a[0]) == null ? void 0 : _b.node) == null ? void 0 : _c.content) == null ? void 0 : _d.content) == null ? void 0 : _e.edges) == null ? void 0 : _f[0]) == null ? void 0 : _g.node) == null ? void 0 : _h.terms) == null ? void 0 : _i.term.find((term) => term.footnote === 8);
  const mainContent = await nodeFinder(content);
  const footnotes = await nodeFinder(footnote);
  parsedContent.title = mainContent == null ? void 0 : mainContent.title;
  parsedContent.content = `${mainContent == null ? void 0 : mainContent.content}${footnotes == null ? void 0 : footnotes.content}`;
  return parsedContent;
}
async function handleContentstackResponse(response, key, memberHandler = membershipHelper, nodeFinder = findContentNodes) {
  let result;
  if (key === "membershipModal") {
    result = await memberHandler(response);
  } else result = await nodeFinder(response.data.pdp_hub.content);
  return result;
}
async function expertAdviceCMSParser(body) {
  const convertToHtml = (await getParser()).default;
  return convertToHtml(body);
}
function getMoreExpertAdviceImg(featImage) {
  var _a, _b, _c;
  if (!featImage) return void 0;
  const { featureImageLinks } = featImage;
  if ((featureImageLinks == null ? void 0 : featureImageLinks.Web_med) === void 0) {
    const availableKey = (_a = Object.keys(featureImageLinks)) == null ? void 0 : _a[0];
    return (_b = featureImageLinks[availableKey]) == null ? void 0 : _b.onlinePublishLink;
  }
  return (_c = featureImageLinks == null ? void 0 : featureImageLinks.Web_med) == null ? void 0 : _c.onlinePublishLink;
}
export {
  expertAdviceCMSParser,
  findContentNodes,
  getMoreExpertAdviceImg,
  handleContentstackResponse,
  membershipHelper
};
//# sourceMappingURL=contentstackHelpers.mjs.map
